module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_vm._v("Chapter One")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("“D")]), _c('span', {
    staticClass: "t4"
  }, [_vm._v("ADDY")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "t4"
  }, [_vm._v("NO")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("!")]), _vm._v(" I don’t want to go to Da’s! I want to stay here and go to Holly’s for her birthday!”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Jesus fuck, six-year-old girls could scream. Kenn’s head was going to explode like an overripe melon. Just "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("boom")]), _vm._v(". “Honey, your Da has you this weekend. It’s not up to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“But he won’t take me! He has to work on his ’puter, and Holly lives here in the ’partments!”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Sarah Jane, enough! I will talk to your da, okay?” Because that was his favorite thing on earth, talking to his ex. His soon-to-be ex. Whatever.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Promise?” Just like that, the sunshine shone through the thunderstorm. “Oh, Daddy. Thank you!”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“I said I’d talk to him. No promises. Micah, get your backpack. It’s time to go to your Da’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Good. Da has the big TV. This one sucks.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Ah, eight going on thirty. What bliss.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“I know, son. I’m sorry, huh? This was what I could afford.” Being a starving artist was way more romantic when your husband was paying all the bills and fronted the cost of the studio. Now he had two part-time jobs and a two-bedroom apartment where he slept on the sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Amazing what an ultimatum could cost a guy.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Whatever. It’s cool, Dad.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("It’s cool, Dad.")]), _vm._v(" So casual, so easy. Micah was growing up so fast.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("The knock came at the door, and Sarah went screaming past him. “Da! Da! Da!”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("God, he hated when Chris came here. He had to be at work in an hour, though. The coffee shop counted on his weekend hours, and he counted on them too.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Sarah’s dark curls bounced everywhere, the wild mass as untameable as his daughter was. She threw the door open, wrapped her arms around Chris, and squealed. “Da! There’s a party at Holly’s!”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Right now?” Chris asked, giving Sarah a bear hug and making her squeal again.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“No, silly Da! Tomorrow! Daddy, tell him.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Kenn looked into the deep dark eyes he’d fallen in love with fifteen years ago. Chris was still the finest man he’d ever seen. He resisted the urge to smooth his hair. Not that it mattered. Chris wouldn’t even look at him for more than a second. “Tomorrow at three. It’s here in the complex. I have the invitation. I told Sue, Holly’s mom, we were a maybe.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Chris sighed, and Kenn refused to notice the dark bags under Chris’s eyes—he wasn’t the only one who was tired.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Please, Da! I wants to go to the party. Daddy would let me go.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“I don’t know, honey. There’s a snowstorm coming in and I have a late phone call tonight and I thought we’d have a family weekend.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Right, because they were still a family. Kenn wasn’t bitter, though. Oh no, not him.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Chris shot an unhappy look in his general direction as Sarah started crying. Like it was his fault. “Look, sweetie, if it’s not snowing, I’ll bring you, okay? If not, I’ve got ice cream and we’ll buy a cake so you won’t miss out.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Kenn always thought it must be nice, being the fun dad.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“And we’ll get her a present?” Sarah asked. “A new Barbie?”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“God, can we just go?” Chris grabbed her pink backpack, which was next to the door. “Micah? Are you ready, son?”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Right here.” Micah rolled his eyes. “See you Sunday, Dad.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Kenn nodded. “I’ll make lasagna.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("He hated this part. Hated it. Hated being alone in his shitty apartment, hated being the oldest man ever to pour coffee for a living, hated being without his Mister Right. Still, it had all been his fault.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Spend more time with us and less at the office or we’re leaving.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("He’d never expected Chris to say, “Then leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Boxing Day had whole new connotations now. While it used to mean boxing up the decorations and whatnot to him, now it meant putting his whole life into boxes.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("Shit, they hadn’t even talked a little bit about what they were going to do for Christmas this year. They’d never spent it apart, even if last year Chris had left at six to go deal with “an emergency” at work. Which had been what had prompted his ultimatum.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“I’ll drop them off at six.” Chris’s words brought him out of his thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Yeah. Sure. Okay. We’ll have to discuss the holidays.” Thanksgiving had been a nonissue. Chris had been overseas in Dubai and he’d taken the kids to his parents for the whole long weekend.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“You just had them for Thanksgiving,” Chris bit out. “I assumed I’d have them for Christmas.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“The whole holiday?” No. No way. Sarah was still little, still excited about Santa, and next year she might not be.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Christmas Day,” Chris told him.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Can we talk about this later?” When the kids weren’t watching them with worried eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Sure. I’ll have Anita call you to set up an appointment.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“Yeah.” Kenn refused to let his hurt show. He was just another inconvenience these days. He supposed he ought to feel grateful the kids were still important to Chris. “You guys have a great weekend. I’ll miss you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Micah rolled his eyes, but Sarah ran to hug him. “I miss you already.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“Yeah, me too.” He locked the door behind them and went to find his uniform shirt. Time to get to work. He had to buy a new Christmas tree, decorations, presents. Single dads had no time for tears.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a756e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/003.vue
// module id = 60
// module chunks = 0